module.exports = __webpack_public_path__ + "static/keyboardshortcut-iconlabel-dont-4d5670a0ea3ea57ede2b6b542ba2ccdd.png";